import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';
import { ObservationsListComponent } from './components/observations-list/observations-list.component'
import { CommonsModule } from '../common/commons.module';
import { DocumentsModule } from "../documents/documents.module";
import { SharedModule } from '../shared/shared.module';
import { QuillModule } from 'ngx-quill';
import { ObservationFormComponent } from './components/observation-form/observation-form.component';
import { CreateOrEditObservationModalComponent } from './components/create-or-edit-observation-modal/create-or-edit-observation-modal.component';
import { CompanyObservationsComponent } from './components/company-observations/company-observations.component';
import { OperativesObservationsComponent } from './components/operatives-observations/operatives-observations.component'
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ButtonModule } from 'primeng/button';;
import { RecentObservationsListComponent } from './components/recent-observations-list/recent-observations-list.component';
import { ObservationDetailsComponent } from './components/observation-details/observation-details.component'
import { TabViewModule } from 'primeng/tabview';
import { ObservationDocumentDetailsPageComponent } from './components/observation-document-details-page/observation-document-details-page.component';

@NgModule({
  declarations: [
    ObservationsListComponent,
    ObservationFormComponent,
    CreateOrEditObservationModalComponent,
    CompanyObservationsComponent,
    OperativesObservationsComponent,
    RecentObservationsListComponent,
    ObservationDetailsComponent,
    ObservationDocumentDetailsPageComponent
  ],

  imports: [
    CommonModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    TableModule,
    InputTextModule,
    RouterModule,
    DocumentsModule,
    CommonsModule,
    FormsModule,
    SharedModule,
    CardModule,
    InputTextareaModule,
    QuillModule,
    ButtonModule,
    RippleModule,
    TabViewModule

  ],

  exports: [ObservationFormComponent, ObservationsListComponent, RecentObservationsListComponent, ObservationDetailsComponent, ObservationDocumentDetailsPageComponent]
})

export class ObservationModule { }
